









import {Vue, Component, Watch, Emit} from 'vue-property-decorator';
import moment from "moment";
import * as _ from 'lodash';

@Component
export default class GodineEditor extends Vue {
    godine = [];
    godina = 0;

    created() {
        const now = moment();
        this.godina = now.get('year');
        this.godine = _.range(0, 5).map(x => this.godina - x);
    }

    @Watch('godina') onGodinaChanged(godina: number) {
        this.input(godina);
    }

    @Emit('input') input(value) {
        console.log(value)
    }
}
